import { findCountryById } from "shared/utils/countrystateutils";

export const countrySupportsPeppol = (value: server.dto.Countries) => {
  const country = findCountryById(value, serverReference);
  return country.isEuMember;
}